import { connect } from 'react-redux'
import {
  selectCurrentAddingNoteAgentIds,
  selectCurrentReplyingAgentIds,
  selectCurrentTypingAgentIds,
  selectCurrentViewingAgentIds,
} from 'selectors/agents/base'
import { selectHasReplyDraft } from 'ducks/drafts'
import View from './view'

const select = state => ({
  addingNoteIds: selectCurrentAddingNoteAgentIds(state),
  hasDraft: selectHasReplyDraft(state),
  replyingIds: selectCurrentReplyingAgentIds(state),
  typingIds: selectCurrentTypingAgentIds(state),
  viewingIds: selectCurrentViewingAgentIds(state),
})

export default connect(select)(View)
